import s from '../styles/FollowUpSuggestions.module.scss'
import { ReactComponent as BlocksIcon } from 'assets/icons/blocks.svg'

/**
 * Related / Follow-up suggestions displayed after bot response.
 * Clicking a suggestion sends it as a new message.
 */
export default function FollowUpSuggestions({ suggestions, onSelect }) {
	if (!suggestions?.length) return null

	return (
		<div className={s.wrap}>
			<div className={s.header}>
				<span className={s.icon}>
					<BlocksIcon />
				</span>
				<span className={s.title}>Related</span>
			</div>

			<div className={s.list}>
				{suggestions.map((text, i) => (
					<button
						key={i}
						className={s.suggestion}
						onClick={() => onSelect && onSelect(text)}
					>
						{text}
					</button>
				))}
			</div>
		</div>
	)
}
